<template>
    <!-- 培训卡 -->	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form :inline="true"  style="float: right;" @submit.native.prevent>
				<!-- <el-form-item>
					<el-input v-model="filters.name" @keyup.enter.native="getTrainingCard"    placeholder="班次名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button size="width:100%; height:100%;" type="primary" v-on:click="getTrainingCard" icon="el-icon-search">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="addTraining">添加套餐项目</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="DataCompensationClicik">业务补偿</el-button>
				</el-form-item>				 -->
                <el-form-item >
                <el-select  v-model="TrainingComboId"  filterable  placeholder="请选择套餐" @change="selectChange" >
                <el-option
                  v-for="item in Trainingoptions"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id">
               </el-option>
                 </el-select>
				</el-form-item> 
              
			</el-form>
		</el-col>
       <!-- <el-table :data="FrequencyCard" >

       </el-table> -->
        <table id="Interval" style="border: 1px solid #ddd;    width: 100%; margin-bottom: 20px;   max-width: 100%;  background-color: transparent;height:200px;" cellspacing="0" cellpadding="0">
           
            <tbody style="width:100%">
                <tr class="active">
                    <th style="text-align: center; width: 14%;background-color: #f5f5f5;">
                        星期一
                    </th>
                    <th style="text-align: center; width: 14%;background-color: #f5f5f5;">
                        星期二
                    </th>
                    <th style="text-align: center; width: 14%;background-color: #f5f5f5;">
                        星期三
                    </th>
                    <th style="text-align: center; width: 14%;background-color: #f5f5f5;">
                        星期四
                    </th>
                    <th style="text-align: center; width: 14%;background-color: #f5f5f5;">
                        星期五
                    </th>
                    <th style="text-align: center; width: 14%; color:#999;" >
                        星期六
                    </th>
                    <th style="text-align: center; width: 14%;color:#999;">
                        星期日
                    </th>
                </tr>
                <tr>
                        <td style="padding: 1px;border: 1px solid #ddd"    >
                            <div class="_cell"  style="min-height: 100px; overflow: hidden;text-align: center;"   ref="Monday">
                                <ol style="list-style-type: none; margin-top: 25px">
                                </ol>
								  <!-- <div slot="reference" class="name-wrapper" v-for="arr in td1" v-on:click.stop="selNum()">	 -->
                                <span slot="reference" class="name-wrapper"    v-for="arr in Monday" v-on:click.stop="selNum(arr,$event)" >                                 
                               <el-tag size="medium"  v-if="IfResult(arr)==false"  data-num="false" >{{arr.StartTime}}-{{arr.EndTime}}</el-tag>  
                              <el-tag size="medium"  v-else  data-num="false" style="background-color: rgb(32, 160, 255);" >{{arr.StartTime}}-{{arr.EndTime}}</el-tag>  
                             
							   	 <br>
							     <br>
                                </span>
								  <!-- </div> -->
                            </div>
                        </td>
                        <td style="padding: 1px;border: 1px solid #ddd;">
                            <div class="_cell"  style="min-height: 100px; overflow: hidden;text-align: center;" ref="Tuesday" data-num="false"   >
                                <ol style="list-style-type: none; margin-top: 25px">
                                </ol>
								  <!-- <div slot="reference" class="name-wrapper" v-for="arr in td1" v-on:click.stop="selNum()">	 -->
                                <span slot="reference" class="name-wrapper"    v-for="arr in Tuesday" v-on:click.stop="selNum(arr,$event)" >                                 
                               <el-tag size="medium"  v-if="IfResult(arr)==false"  data-num="false" >{{arr.StartTime}}-{{arr.EndTime}}</el-tag>  
                              <el-tag size="medium"  v-else  data-num="false" style="background-color: rgb(32, 160, 255);" >{{arr.StartTime}}-{{arr.EndTime}}</el-tag>  
							   	 <br>
							   <br>

                                </span>
								  <!-- </div> -->
                            </div>
                        </td>
                        <td style="padding: 1px;border: 1px solid #ddd;">
                            <div class="_cell"  style="min-height: 100px; overflow: hidden;text-align: center;" ref="Wednesday" data-num="false"   >
                                <ol style="list-style-type: none; margin-top: 25px">
                                </ol>
                                <span slot="reference" class="name-wrapper"    v-for="arr in Wednesday" v-on:click.stop="selNum(arr,$event)" >                                 
                               <el-tag size="medium"  v-if="IfResult(arr)==false"  data-num="false" >{{arr.StartTime}}-{{arr.EndTime}}</el-tag>  
                              <el-tag size="medium"  v-else  data-num="false" style="background-color: rgb(32, 160, 255);" >{{arr.StartTime}}-{{arr.EndTime}}</el-tag>  
							   	 <br>
							   <br>
                                </span>
                            </div>
                        </td>
                        <td style="padding: 1px;border: 1px solid #ddd;">
                            <div class="_cell"  style="min-height: 100px; overflow: hidden;text-align: center;" ref="Thursday" data-num="false"   >
                                <ol style="list-style-type: none; margin-top: 25px">
                                </ol>
                                <span slot="reference" class="name-wrapper"    v-for="arr in Thursday" v-on:click.stop="selNum(arr,$event)" >                                 
                               <el-tag size="medium"  v-if="IfResult(arr)==false"  data-num="false" >{{arr.StartTime}}-{{arr.EndTime}}</el-tag>  
                              <el-tag size="medium"  v-else  data-num="false" style="background-color: rgb(32, 160, 255);" >{{arr.StartTime}}-{{arr.EndTime}}</el-tag>  
							   	 <br>
							   <br>
                                </span>
                            </div>
                        </td>
                        <td style="padding: 1px;border: 1px solid #ddd;">
                            <div class="_cell"  style="min-height: 100px; overflow: hidden;text-align: center;" ref="Friday" data-num="false"   >
                                <ol style="list-style-type: none; margin-top: 25px">
                                </ol>
                                <span slot="reference" class="name-wrapper"    v-for="arr in Friday" v-on:click.stop="selNum(arr,$event)" >                                 
                               <el-tag size="medium"  v-if="IfResult(arr)==false"  data-num="false" >{{arr.StartTime}}-{{arr.EndTime}}</el-tag>  
                              <el-tag size="medium"  v-else  data-num="false" style="background-color: rgb(32, 160, 255);" >{{arr.StartTime}}-{{arr.EndTime}}</el-tag>  
							   	 <br>
							   <br>
                                </span>
                            </div>
                        </td>
                        <td style="padding: 1px;border: 1px solid #ddd;">
                            <div class="_cell"  style="min-height: 100px; overflow: hidden;text-align: center;" ref="Saturday" data-num="false"   >
                                <ol style="list-style-type: none; margin-top: 25px">
                                </ol>
                                <span slot="reference" class="name-wrapper"    v-for="arr in Saturday" v-on:click.stop="selNum(arr,$event)" >                                 
                               <el-tag size="medium"  v-if="IfResult(arr)==false"  data-num="false" >{{arr.StartTime}}-{{arr.EndTime}}</el-tag>  
                              <el-tag size="medium"  v-else  data-num="false" style="background-color: rgb(32, 160, 255);" >{{arr.StartTime}}-{{arr.EndTime}}</el-tag>  
							   	 <br>
							   <br>
                                </span>

                            </div>
                        </td>
                        <td style="padding: 1px;border: 1px solid #ddd;">
                            <div class="_cell"  style="min-height: 100px; overflow: hidden;text-align: center;" ref="Sunday" data-num="false"  >
                                <ol style="list-style-type: none; margin-top: 25px">
                                </ol>
                                <span slot="reference" class="name-wrapper"    v-for="arr in Sunday" v-on:click.stop="selNum(arr,$event)" >                                 
                               <el-tag size="medium"  v-if="IfResult(arr)==false"  data-num="false" >{{arr.StartTime}}-{{arr.EndTime}}</el-tag>  
                              <el-tag size="medium"  v-else  data-num="false" style="background-color: rgb(32, 160, 255);" >{{arr.StartTime}}-{{arr.EndTime}}</el-tag>  
							   	 <br>
							   <br>
                                </span>
                            </div>
                        </td>
                </tr>
            </tbody>
        </table>
      <el-row>
           <el-col :span="4" class="bj" >
               <el-table :data="Interval" max-height="440" >
             	<el-table-column  label="对应日期" style="width:100%" align="center">   
                     <template slot-scope="scope" >
                   <el-tooltip class="item" effect="dark" content="点击查看当日课程统计" placement="left">
                    <el-button
                      @click.native.prevent="columnClick(scope)"
                    type="text"
                   size="small">
                      {{scope.row}}
                   </el-button>
                    </el-tooltip>
                 </template>  
		        </el-table-column>
                </el-table>

           </el-col>
           <el-col :span="6"  class="bj" >
           <div class="xinxitj">人员名单</div>
            <div class="xinxitj">{{OverviewName}}</div>
               <el-table :data="ShiftPlanOutputList" max-height="440" v-loading="listLoading">
             	<el-table-column prop="CardNumber" label="卡号" style="width:100%" align="center">   
		        </el-table-column>
                <el-table-column  prop="MemberName" label="姓名" style="width:100%" align="center">   
                 </el-table-column>
                </el-table>
           </el-col>

            <el-col :span="6"  class="bj">
           <div class="xinxitj">到场人员</div>
               <el-table :data="InFiledList" max-height="440" v-loading="listLoading">
             	<el-table-column prop="CardNumber"  label="卡号" style="width:100%" align="center">   
		        </el-table-column>
                <el-table-column prop="MemberName" label="姓名" style="width:100%" align="center">   
                 </el-table-column>
                </el-table>
           </el-col>
             <el-col :span="6"  >
           <div class="xinxitj">未到人员</div>
               <el-table :data="NotInInFiledList" max-height="440" v-loading="listLoading">
             	<el-table-column prop="CardNumber"  label="卡号" style="width:100%" align="center">   
		        </el-table-column>
                <el-table-column prop="MemberName" label="姓名" style="width:100%" align="center">   
                 </el-table-column>
                </el-table>

           </el-col>
      </el-row>
    </section>
</template>
<script>
import util from '../../common/js/util'
import {IntervalPlan,getIntervalList,getTrainingCardList,addTrainingCard,removeTrainingCard,editTrainingCard,DataCompensation,getTrainingCardOptionsList,IntervalDateList} from '../../api/api';
export default {
	data(){

		return {	
            // 操作时间段是的唯一id
            Interval:[ ],
            Trainingoptions:[],
                 TrainingComboId:'',
                 			  //星期 模型
			  Monday:[],
			  Tuesday:[],
			  Wednesday:[],
			  Thursday:[],
			  Friday:[],
			  Saturday:[],
			  Sunday:[],
        
        //选中后的模型
        listLoading:false,
        ShiftPlanOutputList:[],
        InFiledList:[],
        NotInInFiledList:[],
        OverviewName:'',
        CurrentModel:'',
        CurrentTarget:'',
       TrainingChangeVisible :true,
              SelectMonday:[],
			  SelectTuesday:[],
			  SelectWednesday:[],
			  SelectThursday:[],
			  SelectFriday:[],
			  SelectSaturday:[],
			  SelectSunday:[],
		}
	},
	methods:{	

            columnClick(row)
            {
                // console.log(row);
                this.listLoading=true;
                   this.ShiftPlanOutputList=[];
                   this.InFiledList=[];
                   this.NotInInFiledList=[];

                this.OverviewName=row.row+'('+this.CurrentModel.StartTime+'-'+this.CurrentModel.EndTime+')';
                let para={
                    ComboId:this.TrainingComboId,
                    IntervalId:this.CurrentModel.Id,
                    Date:row.row
                }
                IntervalPlan(para).then((res)=>{
                    // console.log(res.data);
                   this.ShiftPlanOutputList=res.data.Data.ShiftPlanOutputList;
                   this.InFiledList=res.data.Data.InFiledList;
                   this.NotInInFiledList=res.data.Data.NotInInFiledList;
                   this.listLoading=false;
                })
            },
            getIntervalList(Row,e){ 
                let para={ComboId:this.TrainingComboId,IntervalId:Row.Id}
                IntervalDateList(para).then((res)=>{
                    let {Success}=res.data;
                   this.Interval=res.data.Data;
                })
            },
           change(Row,e)
            {
                 if(this.CurrentModel==='')
                {               
                //  e.target.style.backgroundColor ="#20a0ff";
                  e.target.classList.add("ys");
                 e.target.setAttribute('data-num','true');
                 this.CurrentModel=Row;
                 this.CurrentTarget=e;   
                }
                else
                {                   
                // this.CurrentTarget.target.style.backgroundColor = "#8391a5";
                this.CurrentTarget.target.classList.remove("ys");
                this.CurrentTarget.target.setAttribute('data-num','false');
                //   e.target.style.backgroundColor ="#20a0ff"; 样式存在被系统修改的风险
                  e.target.classList.add("ys");
                 e.target.setAttribute('data-num','true');
                  this.CurrentModel=Row;
                 this.CurrentTarget=e;
                }
            },
        	selNum(Row,e){
                   this.ShiftPlanOutputList=[];
                   this.InFiledList=[];
                   this.NotInInFiledList=[];

                this.getIntervalList(Row,e);              
                this.change(Row,e);    
    },
    
        selectChange()
        {
          
          this.selectInterval(this.TrainingComboId);
        },
        getOption()
        {
            let para={}
            getTrainingCardOptionsList(para).then((res)=>{
                // console.log(res);
                    this.Trainingoptions=res.data;
            })
        },
		getTrainingCard(){
		let para = {
					PageIndex: this.page-1,					
					PageSize:10,
					// Name:this.filters.Name
				};
				this.listLoading = true;
				getTrainingCardList(para).then((res)=>{
					this.total = res.data.TotleCount;
					this.FrequencyCard =res.data.Data;
					this.listLoading = false;
				})
				.catch(error=>{
                 alert('网络错误');
                });
        },
     IfResult(arr)
    {
      let result=false;
      switch(arr.WeekName)
				   {					
				   case 'Monday': 
				   {
            let List=this.SelectMonday.filter(i => {
		              return  i.Id == arr.Id});
            if(List.length>0)
            {
              result= true;
            }
            else
            {
              result=false;
            }        
					break;
				   }
				   	case 'Tuesday': 
				   {
            let List=this.SelectTuesday.filter(i => {
		              return  i.Id == arr.Id});
            if(List.length>0)
            {
              result= true;
            }
            else
            {
              result=false;
            }
					break;
					}
				   	case 'Wednesday': 
				   {
            let List=this.SelectWednesday.filter(i => {
		              return  i.Id == arr.Id});
            if(List.length>0)
            {
              result= true;
            }
            else
            {
              result=false;
            }
					break;
				   }
				   	case 'Thursday': 
				   {
            let List=this.SelectThursday.filter(i => {
		              return  i.Id == arr.Id});
            if(List.length>0)
            {
              result= true;
            }
            else
            {
              result=false;
            }
                     break;
				   }
				   	case 'Friday': 
				   {
            let List=this.SelectFriday.filter(i => {
		              return  i.Id == arr.Id});
            if(List.length>0)
            {
              result= true;
            }
            else
            {
              result=false;
            }
					break;
				   }
				   case 'Saturday': 
				   {
            let List=this.SelectSaturday.filter(i => {
		              return  i.Id == arr.Id});
            if(List.length>0)
            {
              result= true;
            }
            else
            {
              result=false;
            }
					break;
				   }
				   case 'Sunday': 
				   {
            let List=this.SelectSunday.filter(i => {
		              return  i.Id == arr.Id});
            if(List.length>0)
            {
              result= true;
            }
            else
            {
              result=false;
            }
					break;
				   }				   				   
				   default:
				     break;
				}
      // console.log('样式'+result);
      return result;   
    },   
            addWeek(data){
         switch (data.WeekName) {
				  case 'Monday': 
				   {
					this.Monday.push(data);
					break;
				   }
				   	case 'Tuesday': 
				   {
					this.Tuesday.push(data);
					break;
					}
				   	case 'Wednesday': 
				   {
					this.Wednesday.push(data);
					break;
				   }
				   	case 'Thursday': 
				   {
					this.Thursday.push(data);
           break;
				   }
				   	case 'Friday': 
				   {
					this.Friday.push(data);
					break;
				   }
				   case 'Saturday': 
				   {
					this.Saturday.push(data);
					break;
				   }
				   case 'Sunday': 
				   {
					this.Sunday.push(data);
					break;
				   }				   				   
				   default:
				     break;
			     }  
	       	},
             selectInterval(Combo){
              if(Combo==null)
              {
                  this.$message({
				            	message: '请选择套餐',
					          	type: 'error'
					        	});
              }
              else
              {                                  

                if(this.TrainingChangeVisible==true)
                {

                   this.Interval=[];
                  //初始化被选中模型的数据为空 初始化培训班选中条件为false 
                 this.Monday=[],
			            this.Tuesday=[],
			            this.Wednesday=[],
			            this.Thursday=[],
			            this.Friday=[],
			            this.Saturday=[],
			            this.Sunday=[],  
                 this.SelectMonday=[],
			            this.SelectTuesday=[],
			            this.SelectWednesday=[],
			            this.SelectThursday=[],
			            this.SelectFriday=[],
			            this.SelectSaturday=[],
			            this.SelectSunday=[],                 
                  this.TrainingChangeVisible=true;
                this.IntervalVisible=true;
                let para={
                     TrainingComboId:Combo
                };
                getIntervalList(para).then((res)=>{
                //   console.log(res);
                	let	{status,data}=res;
                  data.forEach(item => {
						    	 this.addWeek(item); 
					     	  });
                }).catch(error=>{
                 alert('网络错误');
                });		
                }
                else
                {
                  //如果培训班为改变
                this.IntervalVisible=true;
                }
              }
           },
     }
	,
		mounted() {
            // this.getTrainingCard();
            this.getOption();
		}
}
</script>
<style scoped >

.ys{
    background:#20a0ff
}
.bj{
    /* padding-top: 17px; */
padding-right: 10px;
padding-bottom: 45px;
/* padding-left: 16px; */
}
.xinxitj {
    font-size: 16px;
    line-height: 35px;
    border-bottom: solid 1px #c9cdd7;
    margin-bottom: 10px;
}
/* .el-dialog {
    position: absolute;
    left: 50%;
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    background: #fff;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    box-sizing: border-box;
    margin-bottom: 50px;
} */
/* .el-dialog--small {
    width: 80%
} */

</style>



// WEBPACK FOOTER //
// TrainingReport.vue?4d9e4c4d